export const LOCAL_BYPASS_USER_ID =
  "test-user-bypass-00000000-0000-0000-0000";

export function isLocalBypassAuthEnabled(): boolean {
  const env =
    process.env.VERCEL_ENV ||
    process.env.NEXT_PUBLIC_VERCEL_ENV ||
    process.env.NODE_ENV;
  return env !== "production" && process.env.NEXT_PUBLIC_BYPASS_AUTH === "true";
}
